import BaseModalStore from '@src/components/modal-container/base-modal-store';
import { useMount } from 'ahooks';
import { observable } from 'mobx';
import { copyToClipboard } from '@src/utils/common-util';
import message from '@src/components/common-message';
import getUtmSource from '@src/utils/get-utm-source';
class RedeemModalStore extends BaseModalStore {
  constructor(options = {}) {
    super();
    Object.assign(this, options);
  }

  @observable isSteam = false;

  @observable modalTitle = '领取礼包码';

  @observable cdKey = '';

  onClickClose = () => {
    this.isOpen = false;
    this.isActive = false;
    this.clearStyle();
    this.cdKey = '';
    this.isSteam = false;
    this.modalTitle = '领取礼包码';
  };

  copyCdKey = async () => {
    try {
      await copyToClipboard(this.cdKey);
      message.success('复制成功');
    } catch (error) {
      message.fail('拷贝失败');
    }
  };

  fetchCdKey = async () => {
    try {
      const { isDownloadStage } = this.$globalStore;
      const { getCodeInSubscribe, getCodeInDownLoad } = this.$ztService;
      const cdKeyRequest = isDownloadStage ? getCodeInDownLoad : getCodeInSubscribe;
      const res = await cdKeyRequest(getUtmSource());
      this.cdKey = res.code;
    } catch (error) {
      error?.message && message.fail(error?.message);
    }
  };

  use() {
    super.use();

    useMount(() => {
      if (this.isSteam) {
        this.cdKey = '1234567890';
        this.modalTitle = 'STEAM用户可复制以下礼包码';
      } else {
        this.fetchCdKey();
      }
    });
  }
}

export default RedeemModalStore;
